//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'; 
export default {
  name: 'productVerify',
  components: {
  },
  data () {
    return {
      id:0,
      code:'',
      info:{
        goods:[],
      }
    }
  },
  created(){
    this.config();
  },
  mounted(){
    // this.id = Number(this.$route.params.id);
    // this.changePop();
  },
  methods:{
    scanQRCode(){
        let that = this;
        wx.ready(()=> {
            wx.scanQRCode({
            needResult: 1,
            scanType: ["qrCode"],
            success: function (res) {
                setTimeout(()=>{
                    // that.formData[id] = res.resultStr.split(',')[1];
                    that.code = res.resultStr;
                    that.getOrder();
                },300);
            }
            })
        });
        wx.error((res)=> {
            console.log(res)
            // alert(res.errMsg);
        })
    },  
    config(){
        let url = (window.location.href).split('#');
        if(url[0].indexOf('?') != '-1'){
            url = url[0].split('?');
        }
        this.$api.wxSign({url:url[0]}).then((res)=>{
            if(res){
                wx.config({
                    debug: false, 
                    appId: res.data.appId,
                    timestamp: res.data.timestamp,
                    nonceStr: res.data.nonceStr,
                    signature:res.data.signature,
                    jsApiList: [
                        "scanQRCode"
                    ]
                });
            }
        })
    },
    getOrder(){
      let that = this;
      if(!this.code){
        that.$func.showToast('核销码无效');
        return ;
      }
      that.$func.startLoading();
      this.$api.getProductOrder({code:this.code}).then((res)=>{
        if(res){
          that.$func.endLoading();
          that.info = res.data;
        } 
      })  
    },
    submitQrcode(){
      let that = this;
      if(!this.code){
        that.$func.showToast('核销码无效');
        return ;
      }
      that.$func.confirm('确认核销？','温馨提示',()=>{
      that.$func.startLoading();
      that.$api.submitProductQrcode({id:that.info.id}).then((res)=>{
          if(res){
            that.$func.endLoading();
            that.$func.showToast('核销成功');
            that.info = {
              oil:{},
              station:{},
              city:{},
            };
            wx.ready(function () {
                let media = document.getElementById("musicBox");
                media.src = "https://www.yinliwei.com.cn/uploads/default/qrcode.mp3"
                media.play();
            });
          } 
        }) 
      })
       
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/productVerify.vue